// extracted by mini-css-extract-plugin
export default {"dialogTitle":"OnLeaveDialog_dialogTitle__8F96G"};